import React, { useState, useEffect } from "react";
import { FaMapMarkerAlt, FaPhoneAlt, FaEnvelope } from "react-icons/fa";
import "./MiniNavbar.css";
import { useTranslation } from "react-i18next";

// MiniNavbar component definition
function MiniNavbar(props) {
  const [langState, setLangState] = useState(localStorage.getItem("lang"));
  const [profileType, setProfileType] = useState(null);
  const { t } = useTranslation("global");

  // Fetch profile data on component mount
  useEffect(() => {
    if (props.user !== "") {
      fetchProfileData(props.user);
    }
  }, [props.user]);

  // Function to fetch profile data
  const fetchProfileData = async (email) => {
    try {
      const response = await fetch(
        `${process.env.REACT_APP_API_URL}/getProfile`,
        {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
          },
          body: JSON.stringify({ email }),
        }
      );
      const data = await response.json();
      setProfileType(data.type); // Set profile type
    } catch (error) {
      console.error("Error fetching profile data:", error);
    }
  };

  // Function to handle profile navigation
  const handleProfile = () => {
    if (props.user === "") {
      window.location.href = "/loginuser"; // Redirect to login page if user is not logged in
    } else {
      window.location.href = "/profile"; // Redirect to profile page if user is logged in
    }
  };

  // Function to handle dashboard navigation
  const handleDashboard = () => {
    if (props.user === "") {
      window.location.href = "/loginuser"; // Redirect to login page if user is not logged in
    } else if (profileType === "admin") {
      window.location.href = "/admin"; // Redirect to admin page if user is an admin
    } else {
      window.location.href = "/profile"; // Redirect to profile page if user is not an admin
    }
  };

  const handleLogout = () => {
    localStorage.clear(); // Clear local storage
    window.location.href = "/"; // Redirect to home page
  };

  // Function to toggle language between English and Bengali
  const toggleLanguage = () => {
    const newLangState = langState === "en" ? "bn" : "en";
    setLangState(newLangState);
    props.setlangstate(newLangState);
    window.location.reload();
  };

  return (
    <div className="mininavbar">
      <div className="mnv-item-container">
        <div className="mnv-item del">
          <FaMapMarkerAlt className="mnv-icon" />
          <a
            href="https://maps.app.goo.gl/HJE3gTaWhyFWsWsp9"
            className="mnv-link"
          >
            Khulna, Bangladesh
          </a>
        </div>
        <div className="mnv-item del">
          <FaPhoneAlt className="mnv-icon" />
          <a href="tel:01670818914" className="mnv-link">
            +880 1670-818914
          </a>
        </div>
        <div className="mnv-item">
          <FaEnvelope className="mnv-icon" />
          <a href="mailto:contact@latechnologies.net" className="mnv-link">
            contact@latechnologies.net
          </a>
        </div>
      </div>
      <div className="button-container">
        <div
          onClick={handleProfile}
          className={`link-show profile-link ${
            langState === "bn" ? "bangla-font" : ""
          }`}
        >
          {props.user !== "" ? (
            <div>{props.user}</div> // Display username if user is logged in
          ) : (
            <div>{t("navbar.login")}</div> // Display login link if user is not logged in
          )}
        </div>
        <button className="lang-toggle-button" onClick={handleDashboard}>
          Dashboard
        </button>
        {props.user !== "" ? (
          <button className="lang-toggle-button" onClick={handleLogout}>
            Logout
          </button>
        ) : (
          <div style={{ margin: -10 }}></div>
        )}
        <button className="lang-toggle-button" onClick={toggleLanguage}>
          {langState === "en" ? "বাংলা" : "English"}
        </button>
      </div>
    </div>
  );
}

export default MiniNavbar; // Export the MiniNavbar component
